import * as React from "react";

function Marketo(props: React.SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" fill="currentColor" {...props}><path fillRule="evenodd" d="M12,0.5 L12,17.5 L17,14.5 L17,3.5 L12,0.5 Z M10,14.5 L6,16 L6,2 L10,3.5 L10,14.5 Z M1,14 L4,13.5 L4,4.5 L1,4 L1,14 Z" fill="" /></svg>;
}

export default Marketo;